module.exports = __webpack_public_path__ + "static/media/free-scrap-removal-goldcoast.39d14483.png";